﻿angular.module('pipLists', [ 'pipTagList' ]);

import './dependencies/TranslateFilter';
import './tag_list/TagList';
